import { Tooltip } from '@mui/material';
import React, { JSX } from 'react';

type TNoPermissionTooltipProps = {
  isDisabled: boolean;
  children: JSX.Element;
};

const NoPermissionTooltip = (props: TNoPermissionTooltipProps) => {
  const text =
    'This action is unavailable. Contact your adminstrator for more details regarding your user privileges.';
  return (
    <React.Fragment>
      {props.isDisabled ? (
        <Tooltip title={text}>
          <span>{props.children}</span>
        </Tooltip>
      ) : (
        props.children
      )}
    </React.Fragment>
  );
};

export default NoPermissionTooltip;
